import classNames from 'classnames';
import { FC, useContext } from 'react';

import { StylesheetContext } from '../../contexts/StylesheetContext';
import { isSFChatAvailable } from '../../services/ChatService';
import { ActionContainer } from '../ActionContainer/ActionContainer';
import { FAQComponent } from './FAQComponent';
import style from './FAQPhoneContainer.module.scss';

export const FAQPhoneContainer: FC = () => {
  const { stylesheet: { contact: { showPhoneNumberInFooter, showFaqInFooter } } } = useContext(StylesheetContext);

  if (showFaqInFooter === false && showPhoneNumberInFooter === false) {
    return null;
  }

  const fullRowWidth = !isSFChatAvailable();

  return (
    <>
      <ActionContainer
        bgClassName={classNames({
          [style.root]: true,
          [style.noBorderMobile]: true,
          [style.noBorder]: fullRowWidth,
        })}
        innerStyle={classNames({
          [style.inner]: true,
          [style.noPaddingWide]: fullRowWidth,
          [style.noPaddingMobile]: true,
        })}>
        <FAQComponent/>
      </ActionContainer>
    </>
  );
};
